<ng-content></ng-content>
<small id="username-help" class="p-error">{{ currentMessage() }}</small>